@if (isAccessGranted) {
    <router-outlet></router-outlet>
    <app-admin-impersonation-banner></app-admin-impersonation-banner>
    <app-migration-notice-modal
        [visible]="showMigrationNotice()"
        (acknowledge)="onMigrationNoticeAcknowledge()">
    </app-migration-notice-modal>
} @else {
    <div class="access-denied">
        <h1>Access Denied</h1>
        <p>You do not have permission to view this site.</p>
        <button (click)="retryAccess()">Try Again</button>
    </div>
}
